import { mapGroupsWithEntries } from "@/helpers/groups.js";
import { filterPointsByWeek } from "@/helpers/common.js";
import { GROUP_DETAILS } from "@/data/enums.js";

const DEFAULT_GROUP = {
  id: 0,
  name: "",
  color: "",
  index: 0,
  pointsAllTime: 0,
  pointsWeekly: 0,
  members: []
};

const groups = {
  namespaced: true,
  state: {
    groups: [],
    groupsLoaded: false
  },
  mutations: {
    SET_GROUPS(state, groups) {
      state.groupsLoaded = true;
      state.groups = groups;
    }
  },
  actions: {
    setGroups({ commit }, groups) {
      commit("SET_GROUPS", groups);
    }
  },
  getters: {
    getGroups(state) {
      let groups = state.groups.map((group) => ({
        ...DEFAULT_GROUP,
        ...group,
        index: parseInt(
          GROUP_DETAILS.find((g) => g.name === group.name)?.group || ""
        ),
        color: `group${GROUP_DETAILS.find((g) => g.name === group.name)?.group || ""}` //`group${index}`
      }));
      return groups;
    },
    getGroupByUserId: (state, getters) => (userId) => {
      const userGroup = getters.getGroups.find((group) => {
        const userFound = group.members.find((member) => {
          return member.id === parseInt(userId);
        });

        return userFound;
      });

      return userGroup || {};
    },
    getMyGroup(state, getters, rootState, rootGetters) {
      return getters.getGroupByUserId(rootGetters.getUserId);
    },
    // Returns groups with their members with their entry data and calculated points
    getMappedGroups(state, getters, rootState, rootGetters) {
      let entries = rootGetters["datastore/getEntries"];
      let groups = getters.getGroups;
      let awardedPoints = rootGetters["content/getAwardedPoints"];

      let mappedGroups = mapGroupsWithEntries(groups, entries);

      //console.log("Mapped Groups:", mappedGroups);

      // Add points for each group from instructor
      mappedGroups.forEach((group) => {
        let awardedPointEntries = awardedPoints.filter(
          (entry) => entry.name.toLowerCase() === group.name.toLowerCase()
        );

        if (awardedPointEntries) {
          // Add all time points for the group from the instructor
          awardedPointEntries.forEach((entry) => {
            group.pointsAllTime += entry.points;
          });

          let filteredPoints = filterPointsByWeek(awardedPointEntries);

          // If there are any points for this week, add them to the group's weekly points
          if (filteredPoints.length > 0) {
            filteredPoints.forEach((entry) => {
              group.pointsWeekly += entry.points;
            });
          }
        }
      });

      return mappedGroups;
    },
    // Returns the user's group with member entry data and calculated points
    getMyMappedGroup(state, getters) {
      let mappedGroups = getters.getMappedGroups;

      let myMappedGroup = mappedGroups.find(
        (group) => group.id === getters.getMyGroup.id
      );

      return myMappedGroup;
    }
  }
};

export default groups;
